import { useRef } from 'react';
import ReportAPI from 'api/report.api';
import MaterialMovementReportBase from './MaterialMovementReportBase';

const MaterialMovementReport = () => {
  const reportApi = useRef(new ReportAPI()).current;

  return (
    <MaterialMovementReportBase
      titleKey="material_movement_report_title"
      primaryField="excavator"
      csvFilenamePrefix="material-movement-report"
      fetchReport={reportApi.getMaterialMovementReport}
    />
  );
};

export default MaterialMovementReport;
